/** 
 * @typedef AjaxOption
 * @property {string} url 必須
 * @property {string} method 既定値は"GET"
 * @property {object} headers HTTPヘッダの追加設定
 * @property {any} body bodyに設定するデータ
 * @property {"text" | "blob"} responseType レスポンスの処理。規定値は"text"
 */
/**
 * @typedef AjaxResponse
 * @property {boolean} ok 成功/失敗 
 * @property {number} status レスポンスコード。通信異常時は0
 * @property {string} statusText レスポンスコード名
 * @property {string | blob} body レスポンスbody
 */


export const Auth = new function () {
    const me = this
    const keyL = "auth.login"
    const keyR = "auth.refresh"
    const Setting = window.Setting

    //methods
    this.ajax = ajaxWithAuth;
    this.login = login;
    this.logout = clear;
    this.isKeep = isKeep;
    this.refresh = refresh;
    this.getLoginToken = getLoginToken;
    this.getRefreshToken = getRefreshToken;
    this.getAuthState = function(){
        return detect(getLoginToken())
    };
    this.getAuthorizationHeader = function () {
        return 'Bearer ' + getLoginToken()
    };

    //event
    //認証不良の場合に行う処理
    this.onUnAuthorized = null;

    //functions
    function getLoginToken() {
        let itm = localStorage.getItem(keyL)
        return (itm != null) ? itm : sessionStorage.getItem(keyL)
    }

    function getRefreshToken() {
        let itm = localStorage.getItem(keyR)
        return (itm != null) ? itm : sessionStorage.getItem(keyR)
    }

    function setToken(login, refresh, keep) {
        if (keep) {
            localStorage.setItem(keyL, login)
            localStorage.setItem(keyR, refresh)
        } else {
            sessionStorage.setItem(keyL, login)
            sessionStorage.setItem(keyR, refresh)
        }
    }

    function clear() {
        localStorage.removeItem(keyL)
        localStorage.removeItem(keyR)
        sessionStorage.removeItem(keyL)
        sessionStorage.removeItem(keyR)
    }

    function isAuthorized(){
        return getRefreshToken() != null;
    }

    function isKeep() {
        return localStorage.getItem(keyR) != null
    }

    function copyHash(org) {
        let ret = {}
        if (!org) return ret

        Object.keys(org).forEach(function (key) {
            ret[key] = org[key]
        })
        return ret;
    }

    /**
     * トークンを解析しペイロードを取得します。
     * ログインしていない場合nullが返ります。
     * @param {any} token トークン
     * @returns {object} ペイロード
     */
    function detect(token) {
        if (token == null) return null;

        let t = token.split(".");
        if (t.Length < 3) return null;
        t = t[1];

        let pads = (4 - t.Length % 4) % 4;
        for (let i = 0; i < pads; i++) t += "=";
        t = t.replace('-', '+');
        t = t.replace('_', '/');
        t = window.atob(t);
        return JSON.parse(t);
    }

    /**
     * 認証付きのリクエストを送信します。
     * @param {AjaxOption} options リクエスト設定
     * @returns { Promise<AjaxResponse> } レスポンス情報
     */
    async function ajaxWithAuth(options) {
        //事前のトークン有効チェックはクライアント時刻に
        //左右されるのでやらない
        let ret = await request(0)
        return ret

        async function request(retry) {
            let opts = copyHash(options)
            opts.headers = copyHash(options.headers)

            let ltoken = getLoginToken()
            if (ltoken != null) {
                opts.headers['Authorization'] = 'Bearer ' + ltoken
            }

            let res = await ajax(opts)

            if (res.status == 401 && isAuthorized() && retry < 1) {
                //トークン切れ、更新して再リクエスト
                let isRefresh = await refresh()
                if (isRefresh) {
                    return await request(retry + 1)
                }
            }

            //認証不良
            if(res.status == 401 || res.status == 403){
                if(me.onUnAuthorized) {
                    me.onUnAuthorized()
                }
            }

            return res
        }
    }

    /**
     * トークンを更新します。
     * @returns {boolean} 成否
     */
    async function refresh() {
        let rtoken = getRefreshToken();
        let res = await ajax({
            url: Setting.api+"user/refresh",
            method: "POST",
            body: { refreshToken: rtoken },
        })

        if (res.ok) {
            let obj = JSON.parse(res.body)
            let lt = obj["loginToken"]
            let rt = obj["refreshToken"]
            setToken(lt, rt, isKeep())
        } else {
            if (res > 0) {
                //通信エラーのときはクリアしない
                //(ログアウトしない)
                clear()
            }
        }
        return res.ok
    }

    /**
     * ログインします。
     * @param {string} id ユーザID
     * @param {string} password パスワード
     * @param {boolean} keep ログインを維持するか
     * @returns {object} okとstatusを持つ連想配列
     */
    async function login(id, password, keep) {
        var res = await ajax({
            method: "POST",
            url: Setting.api+"user/login",
            body: { id: id, password: password },
        })

        if (res.ok) {
            let obj = JSON.parse(res.body)
            let lt = obj["loginToken"]
            let rt = obj["refreshToken"]
            setToken(lt, rt, keep)
        } else {
            clear()
        }

        return {
            ok: res.ok,
            status: res.status,
        }
    }

    /**
     * リクエストを送信します。
     * @param {AjaxOption} options リクエスト設定
     * @returns {AjaxResponse} レスポンス情報
     */
    async function ajax(options) {
        let init = {}
        init.method = options.method || "GET"
        init.headers = options.headers || {}
        if ("body" in options) {
            if(!("Content-Type" in init.headers) || init.headers["Content-Type"].startsWith("application/json")){
                init.headers["Content-Type"] = "application/json;charset=UTF-8"
                init.body = JSON.stringify(options.body)
            }else{
                init.body = options.body
            }
        }

        try {
            let res = await fetch(options.url, init)
            let ret = {
                ok: res.ok,
                status: res.status,
                statusText: res.statusText,
            }

            if(!res.ok){
                ret.body = await res.text()
            }else if(!("responseType" in options)){
                ret.body = await res.text()
            }else if(options["responseType"] == "text"){
                ret.body = await res.text()
            }else if(options["responseType"] == "blob"){
                ret.body = await res.blob()
            }
            return ret
        } catch (ex) {
            let ret = {
                ok: false,
                status: 0,
                statusText: "" + ex,
                body: "" + ex,
            }
            return ret
        }
    }
}

window.Auth = Auth